
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface UserStore {
  role: any;
  setRole: (role: string | null) => void;
}

export const useUserStore = create<UserStore>()(
  persist(
    (set) => ({
      role: null,
      setRole: (role) => set({ role }),
    }),
    {
      name: "user-store",
      partialize: (state) => ({ role: state.role }),
    }
  )
);
